// @flow
import React from 'react';
import config from '../config';

const firebase = window.firebase;
let firebasePerf;
if (firebase) {
  firebase.initializeApp(config.FIREBASE_CONFIG);
  firebasePerf = firebase.performance();
}

const FirebaseContext = React.createContext<null>(null);

export {
  firebase,
  firebasePerf,
  FirebaseContext
};